/**
 * Helper function to normalize a date by removing the time component.
 *
 * @param {string|Date} date - The date to normalize.
 * @returns {Date} - A date object set to 00:00:00.
 */
export const normalizeDate = date => {
  const d = new Date(date)
  return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}
